import { createIdSlice } from '../utils/action/createElementSlice';
export const MaximizeState = createIdSlice({
    elementName: 'maximize',
    initialState: {},
    reducers: {
        set(_state, action) {
            return action.payload.data;
        },
        update(state, action) {
            if (!state) {
                return;
            }
            return Object.assign(Object.assign({}, state), action.payload.data);
        },
    },
});
